import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { ArrowUpRight } from "lucide-react";
import { useSettings } from "@/lib/SettingsContext";
import { isPromoActive, promoKey } from "@/lib/promo";

const API = process.env.REACT_APP_BACKEND_URL;

export const PromoPopup = () => {
  const promo = useSettings().promo;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isPromoActive(promo) || !promo.showPopup || !promo.flyerUrl) return;
    const key = promoKey(promo);
    if (sessionStorage.getItem(key)) return;
    const t = setTimeout(() => {
      if (window.__adminOpen || window.location.search.includes("openadmin")) return;
      setOpen(true);
      sessionStorage.setItem(key, "1");
    }, 1200);
    return () => clearTimeout(t);
  }, [promo]);

  if (!isPromoActive(promo) || !promo.flyerUrl) return null;
  const src = promo.flyerUrl.startsWith("http") ? promo.flyerUrl : `${API}${promo.flyerUrl}`;
  const hasCta = promo.bannerCtaUrl && promo.bannerCtaLabel;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg p-0 overflow-hidden bg-white border-slate-200 z-[80]" data-testid="promo-popup">
        <DialogTitle className="sr-only">Promotion</DialogTitle>
        <DialogDescription className="sr-only">Current NTOA promotion. Click to learn more.</DialogDescription>
        {promo.bannerCtaUrl ? (
          <a href={promo.bannerCtaUrl} className="block" data-testid="promo-flyer-link">
            <img src={src} alt={promo.flyerAlt || "Promotion"} className="w-full h-auto block" data-testid="promo-flyer-img" />
          </a>
        ) : (
          <img src={src} alt={promo.flyerAlt || "Promotion"} className="w-full h-auto block" data-testid="promo-flyer-img" />
        )}
        {hasCta && (
          <div className="p-4">
            <a
              href={promo.bannerCtaUrl}
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-amber-500 text-white font-bold hover:bg-amber-600 transition-colors"
              data-testid="promo-popup-cta"
            >
              {promo.bannerCtaLabel} <ArrowUpRight size={18} />
            </a>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
